module.exports = __webpack_public_path__ + "img/Tigre_lock.317bc3ad.svg";